import { Checkbox, TableCell, TableHead, type TableHeadProps, TableRow } from "@mui/material";
import { type Ref, forwardRef } from "react";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTableHead = forwardRef(function VirtuosoTableHead(
  { children, ...props }: TableHeadProps,
  ref: Ref<HTMLTableSectionElement>
) {
  const { TableHeadProps, hiddenCheckbox, allCheckboxProps, toggleAllCheckbox } = useTableVirtualizedSelectContext();

  return (
    <TableHead {...props} {...TableHeadProps} sx={{ backgroundColor: "inherit" }} ref={ref}>
      <TableRow>
        {!hiddenCheckbox && (
          <TableCell sx={{ width: 32 }}>
            <Checkbox sx={{ p: 0 }} {...allCheckboxProps} onClick={toggleAllCheckbox} />
          </TableCell>
        )}
        {children}
      </TableRow>
    </TableHead>
  );
});
